// Textos de flotas de taxi/VTC (docs/flotas-drivers). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'ca',
  data: {
    DRIVERS_FLEET: {
      MODE: {
        taxi: 'Taxi',
        vtc: 'VTC',
      },
      FLEET_STATUS: {
        draft: 'Alta sense enviar',
        in_review: 'En revisió',
        rejected: 'Rebutjada',
        approved: 'Aprovada',
        suspended: 'Suspesa',
      },
      DOC_STATUS: {
        pending: 'Pendent',
        in_review: 'En revisió',
        approved: 'Aprovat',
        rejected: 'Rebutjat',
        expired: 'Caducat',
        expiring_soon: 'Caduca aviat',
      },
      EXPIRY: {
        none: 'Sense caducitat',
        valid: 'Caduca el {{date}}',
        expiring_soon: 'Caduca aviat: {{date}}',
        expired: 'Va caducar el {{date}}',
      },
      OWNER_TYPE: {
        fleet: 'Flota',
        vehicle: 'Vehicle',
        driver: 'Conductor',
      },
      DOC_TYPE: {
        billing_info: 'Dades de facturació',
        bank_ownership_certificate: 'Certificat de titularitat bancària',
        route_sheet_authorization: 'Apoderament de fulls de ruta',
        circulation_permit: 'Permís de circulació',
        technical_sheet_itv: 'Fitxa tècnica amb ITV vigent',
        insurance_policy: 'Pòlissa de l\'assegurança del vehicle',
        taxi_municipal_license: 'Llicència municipal de taxi',
        vtc_transport_card: 'Targeta de transport VTC',
        identity: 'Verificació d\'identitat',
        driving_license: 'Carnet de conduir',
        taxi_driver_card: 'Carnet de conductor d\'autotaxi',
        vtc_driver_permit: 'Permís de conductor VTC',
        social_security_registration: 'Alta a la Seguretat Social',
      },
      REJECTION_REASON: {
        illegible: 'Il·legible',
        expired: 'Caducat',
        holder_mismatch: 'No coincideix el titular',
        plate_mismatch: 'No coincideix la matrícula',
        wrong_document: 'Document incorrecte',
        other: 'Un altre motiu',
      },
      ROLE: {
        fleet_owner: 'Propietari',
        fleet_manager: 'Gestor',
        fleet_accountant: 'Comptable',
      },
      MEMBERSHIP_STATUS: {
        pending: 'Sol·licitud pendent',
        accepted: 'Acceptat',
        rejected: 'Rebutjat',
        removed: 'Desvinculat',
      },
      EMPLOYMENT_TYPE: {
        salaried: 'Assalariat',
        self_employed: 'Autònom',
      },
      VEHICLE_STATUS: {
        incomplete: 'Falten documents',
        in_review: 'En revisió',
        rejected: 'Rebutjat',
        approved: 'Aprovat',
      },
      SHIFT_SLOT: {
        morning: 'Matí',
        afternoon: 'Tarda',
        night: 'Nit',
      },
      UPLOAD: {
        HINT: 'JPG, PNG o PDF, fins a 30 MB.',
        SUBMIT: 'Pujar',
        RESUBMIT: 'Tornar a pujar',
        UPLOADING: 'Pujant…',
        ERROR_TYPE: 'L\'arxiu ha de ser JPG, PNG o PDF.',
        ERROR_SIZE: 'L\'arxiu no pot superar 30 MB.',
      },
      VIEWER: {
        EMPTY: 'Encara no s\'ha pujat aquest document.',
        NO_PREVIEW: 'No es pot previsualitzar aquest arxiu.',
        OPEN: 'Obrir en una pestanya nova',
      },
      ONBOARDING_STATUS: {
        in_progress: 'Alta a mitges',
        in_review: 'En revisió',
        rejected: 'Alguna cosa rebutjada',
        approved: 'Aprovat',
      },
      WORKING_AS: {
        own_license: 'Llicència pròpia',
        fleet_self_employed: 'Autònom en flota',
        fleet_salaried: 'Assalariat en flota',
      },
      DOC_SHORT: {
        circulation_permit: 'Circulació',
        technical_sheet_itv: 'ITV',
        insurance_policy: 'Assegurança',
        taxi_municipal_license: 'Llicència',
        vtc_transport_card: 'Targeta VTC',
      },
      ADMIN: {
        LOADING: 'Carregant…',
        RETRY: 'Tornar-ho a provar',
        OPEN: 'Obrir',
        VIEW: 'Veure',
        REVIEW_ACTION: 'Revisar',
        PREVIOUS: 'Anterior',
        NEXT: 'Següent',
        YES: 'Sí',
        NO: 'No',
        MODE_ALL: 'Taxi i VTC',
        MODE_ARIA: 'Taxi o VTC',
        REGION_ALL: 'Totes les regions',
        REGION_ARIA: 'Regió',
        COL_MODE: 'Mode',
        COL_REGION: 'Regió',
        COL_STATUS: 'Estat',
        COL_CREATED: 'Alta',
        CAN_WORK: 'Pot treballar',
        OWN_LICENSE: 'Llicència pròpia',
        DOCS_APPROVED: '{{approved}} de {{total}} aprovats',
        DOCS_IN_REVIEW: '{{count}} en revisió',
        DOCS_REJECTED: '{{count}} rebutjats',
        BILLING: 'Facturació',
        BILLING_LEGAL_NAME: 'Raó social',
        BILLING_TAX_ID: 'NIF',
        BILLING_ENTITY: 'Factura com a',
        BILLING_ENTITY_company: 'Empresa',
        BILLING_ENTITY_self_employed: 'Autònom',
        BILLING_ADDRESS: 'Domicili fiscal',
        BILLING_VAT: 'Règim d\'IVA',
        BILLING_NONE: 'Encara no ha omplert les dades de facturació.',
        VAT_general: 'General',
        VAT_simplified: 'Simplificat',
        VAT_exempt: 'Exempt',
        REVIEWS: {
          TABS_ARIA: 'Estat de la revisió',
          TAB_IN_REVIEW: 'Pendents',
          TAB_APPROVED: 'Aprovats',
          TAB_REJECTED: 'Rebutjats',
          PANEL_TITLE_in_review: 'Pendents de revisar',
          PANEL_TITLE_approved: 'Documents aprovats',
          PANEL_TITLE_rejected: 'Documents rebutjats',
          PANEL_SUB_in_review: 'Els que porten més temps esperant, primer. En obrir-ne un es veu l\'arxiu al costat de les seves dades.',
          PANEL_SUB_approved: 'Documents ja aprovats, amb la data de caducitat.',
          PANEL_SUB_rejected: 'Documents rebutjats i el motiu que se li va donar a l\'usuari.',
          SEARCH: 'Cercar flota, conductor o matrícula',
          OWNER_ALL: 'Qui el puja: tots',
          OWNER_ARIA: 'Qui el puja',
          TYPE_ALL: 'Tots els documents',
          TYPE_ARIA: 'Tipus de document',
          SORT_OLDEST: 'Més antics primer',
          SORT_NEWEST: 'Més recents primer',
          SORT_ARIA: 'Ordre',
          COL_DOCUMENT: 'Document',
          COL_OWNER: 'De',
          COL_OWNER_TYPE: 'Tipus',
          COL_UPLOADED: 'Pujat',
          VERSION: 'Versió {{version}}',
          OWN_LICENSE_OF: 'Llicència pròpia de {{name}}',
          EMPTY_in_review: 'No hi ha documents pendents de revisar.',
          EMPTY_approved: 'Encara no hi ha documents aprovats.',
          EMPTY_rejected: 'No hi ha documents rebutjats.',
          EMPTY_FILTERED: 'Cap document coincideix amb els filtres.',
          LOAD_ERROR: 'No s\'han pogut carregar els documents.',
          SHOWING: 'Mostrant {{shown}} de {{total}} documents',
          PER_PAGE: '{{count}} per pàgina',
          PER_PAGE_ARIA: 'Documents per pàgina',
        },
        REVIEW: {
          TITLE: 'Revisió de document',
          BACK: 'Tornar a la cua',
          NEXT_PENDING: 'Següent pendent',
          LOAD_ERROR: 'No s\'ha pogut carregar el document.',
          DOCUMENT: 'Document',
          UPLOADED: 'Pujat el {{date}} per {{name}}',
          REVIEW: 'Revisió',
          APPROVE_TITLE: 'Aprovar',
          APPROVE_HELP_NONE: 'Aquest document no caduca ni porta número: n\'hi ha prou de comprovar que és correcte.',
          EXPIRES_AT: 'Data de caducitat',
          EXPIRES_HINT: 'Amb ella s\'avisa la flota que caduca aviat o ha caducat.',
          EXPIRES_REQUIRED: 'Indica la data de caducitat.',
          LICENSE_NUMBER: 'Núm. de llicència',
          AUTHORIZATION_NUMBER: 'Núm. d\'autorització',
          LICENSE_REQUIRED: 'Indica el número que apareix al document.',
          APPROVE: 'Aprovar document',
          APPROVING: 'Aprovant…',
          REJECT_TITLE: 'Rebutjar',
          REASON: 'Motiu',
          REASON_PLACEHOLDER: 'Tria un motiu',
          REASON_REQUIRED: 'Tria el motiu del rebuig.',
          COMMENT: 'Comentari',
          COMMENT_PLACEHOLDER: 'Què ha de corregir, en una frase.',
          COMMENT_HINT: 'L\'usuari el veurà al costat del motiu.',
          COMMENT_REQUIRED: 'Amb «Un altre motiu», explica què passa.',
          REJECT: 'Rebutjar document',
          REJECTING: 'Rebutjant…',
          DONE_APPROVED: 'Document aprovat. S\'ha avisat l\'usuari.',
          DONE_REJECTED: 'Document rebutjat. S\'ha avisat l\'usuari amb el motiu.',
          NO_MORE_PENDING: 'No queden més documents pendents.',
          ALREADY_REVIEWED: 'Una altra persona ja havia revisat aquest document. Es mostra la seva decisió.',
          ACTION_ERROR: 'No s\'ha pogut desar la revisió.',
          REVIEWED_BY: 'Revisat per',
          OWNER: 'De qui és',
          IDENTITY: 'Identitat (Tecalis)',
          IDENTITY_BY: 'el {{date}}',
          IDENTITY_NONE: 'Encara sense verificar',
          HISTORY: 'Historial',
          HISTORY_uploaded: 'Pujat per {{name}}',
          HISTORY_approved: 'Aprovat per {{name}}',
          HISTORY_rejected: 'Rebutjat per {{name}}',
          PREVIOUS_VERSIONS: 'Versions anteriors',
        },
        FLEETS: {
          TABS_ARIA: 'Estat de la flota',
          TAB_ALL: 'Totes',
          PANEL_TITLE: 'Totes les flotes',
          PANEL_SUB: 'Una flota pot treballar quan tots els seus documents d\'empresa estan aprovats.',
          SEARCH: 'Cercar per nom, correu o codi',
          COL_FLEET: 'Flota',
          COL_VEHICLES: 'Vehicles',
          COL_DRIVERS: 'Conductors',
          COL_REQUESTS: 'Sol·licituds',
          EMPTY: 'No hi ha flotes que coincideixin.',
          LOAD_ERROR: 'No s\'han pogut carregar les flotes.',
          SHOWING: 'Mostrant {{shown}} de {{total}} flotes',
          PER_PAGE: '{{count}} per pàgina',
          PER_PAGE_ARIA: 'Flotes per pàgina',
        },
        FLEET: {
          APPROVE_BILLING: 'Aprovar dades',
          REJECT_BILLING: 'Rebutjar',
          CONFIRM_REJECT_BILLING: 'Rebutjar dades de facturació',
          TITLE: 'Fitxa de la flota',
          BACK: 'Tornar a flotes',
          LOAD_ERROR: 'No s\'ha pogut carregar la flota.',
          CODE: 'Codi',
          SUBMITTED: 'Enviada a revisió',
          NOT_SUBMITTED: 'Sense enviar',
          ONBOARDING: 'Alta de la flota',
          ONBOARDING_SUB: 'Dades de facturació i documents d\'empresa.',
          VEHICLES: 'Vehicles',
          VEHICLES_SUB: 'Un vehicle pot treballar quan tots els seus documents estan aprovats i al dia.',
          NO_VEHICLES: 'Encara no ha donat d\'alta cap vehicle.',
          PLATE: 'Matrícula',
          CAR: 'Vehicle',
          DOCUMENTS: 'Documents',
          DRIVERS: 'Conductors',
          DRIVERS_SUB: 'Vinculats pel codi de flota.',
          NO_DRIVERS: 'Encara no hi ha conductors vinculats.',
          RELATION: 'Relació',
          SHARE: 'Repartiment',
        },
        DRIVERS: {
          TABS_ARIA: 'Estat de l\'alta',
          TAB_ALL: 'Tots',
          PANEL_TITLE: 'Tots els conductors',
          PANEL_SUB: 'Un conductor no es pot connectar fins que tots els seus passos estan aprovats.',
          SEARCH: 'Cercar per nom, correu, telèfon o flota',
          WORKING_AS_ALL: 'Com treballa: tots',
          WORKING_AS_ARIA: 'Com treballa',
          COL_WORKING_AS: 'Com treballa',
          COL_STEPS: 'Passos',
          EMPTY: 'No hi ha conductors que coincideixin.',
          LOAD_ERROR: 'No s\'han pogut carregar els conductors.',
          SHOWING: 'Mostrant {{shown}} de {{total}} conductors',
          PER_PAGE: '{{count}} per pàgina',
          PER_PAGE_ARIA: 'Conductors per pàgina',
        },
        DRIVER: {
          TITLE: 'Fitxa del conductor',
          BACK: 'Tornar a conductors',
          LOAD_ERROR: 'No s\'ha pogut carregar el conductor.',
          VIEW_USER: 'Veure fitxa d\'usuari',
          DOCUMENTS: 'Passos de l\'alta',
          DOCUMENTS_SUB: 'Documents que ha pujat des de l\'app.',
          OWN_VEHICLE: 'Del seu vehicle',
          IDENTITY_TECALIS: 'El verifica Tecalis',
          FLEETS: 'Flotes',
          NO_FLEETS: 'No ha estat en cap flota.',
        },
      },
      HUB: {
        SECTION: 'Flotes de taxi i VTC',
        NEW_SECTION: 'Nova flota de taxi o VTC',
        CREATE_TITLE: 'Donar d\'alta una flota',
        CREATE_META: 'Gestiona les teves llicències, vehicles i conductors de taxi o VTC.',
      },
      SIGNUP: {
        TITLE: 'Alta d\'una flota',
        SUBTITLE: 'Dona d\'alta la teva empresa de taxi o VTC. Després afegiràs els vehicles i els conductors des del panell.',
        BACK_TO_HUB: 'Tornar al tauler',
        BACK: 'Enrere',
        STEP_OF: 'Pas {{step}} de {{total}}',
        NEXT: 'Següent',
        CREATE: 'Crear la flota',
        CREATING: 'Creant…',
        START_TITLE: 'La teva empresa',
        START_SUB: 'On treballes i com t\'escrivim.',
        NAME: 'Nom de la flota',
        NAME_HINT: 'El nom amb què et veuran els teus conductors.',
        NAME_REQUIRED: 'Escriu el nom de la flota.',
        REGION: 'Ciutat',
        REGION_PLACEHOLDER: 'Tria la ciutat',
        REGION_REQUIRED: 'Tria la ciutat on treballa la flota.',
        EMAIL: 'Correu de l\'empresa',
        EMAIL_HINT: 'Allà t\'avisarem de la revisió dels documents.',
        EMAIL_INVALID: 'Escriu un correu vàlid.',
        CATALOG_ERROR: 'No s\'han pogut carregar les ciutats.',
        ACTIVITY_TITLE: 'A què es dedica la flota?',
        ACTIVITY_SUB: 'Una flota és de taxi o de VTC: decideix quins documents es demanen.',
        ACTIVITY_REQUIRED: 'Tria a què es dedica la flota.',
        MODE_NOTE_TITLE: 'No es pot canviar després',
        MODE_NOTE_TEXT: 'Taxi i VTC no es barregen en una mateixa flota. Si tens les dues activitats, dona d\'alta una flota per a cadascuna.',
        CREATE_ERROR: 'No s\'ha pogut crear la flota.',
      },
      ONBOARDING: {
        SUBTITLE_DRAFT: 'Completa els passos i envia\'ls a revisió. Els vehicles s\'afegeixen després, des del panell.',
        SUBTITLE_SENT: 'L\'estat de cada pas de la teva alta.',
        GO_TO_PANEL: 'Anar al panell',
        PROGRESS: '{{done}} de {{total}} passos completats',
        CATALOG_ERROR: 'No s\'han pogut carregar les dades de l\'alta.',
        STEP_HINT_billing_info: 'Entitat, raó social, NIF, adreça i IVA.',
        STEP_HINT_bank_ownership_certificate: 'A nom de l\'empresa i amb l\'IBAN visible.',
        STEP_HINT_route_sheet_authorization: 'Autoritza WAIIS al Registre VTC del Ministeri.',
        STEP_pending: 'Pendent',
        STEP_ready: 'Llest',
        STEP_in_review: 'En revisió',
        STEP_approved: 'Aprovat',
        STEP_rejected: 'Rebutjat',
        STATUS_TITLE_draft: 'Alta sense enviar',
        STATUS_TITLE_in_review: 'Flota en revisió',
        STATUS_TITLE_rejected: 'Hi ha alguna cosa a corregir',
        STATUS_TITLE_approved: 'Flota aprovada',
        STATUS_TITLE_suspended: 'Flota suspesa',
        STATUS_TEXT_draft: 'Completa els passos i envia l\'alta.',
        STATUS_TEXT_in_review: 'Estem revisant els teus documents. Mentrestant pots entrar al panell, però els teus conductors no es podran connectar fins que la flota estigui aprovada.',
        STATUS_TEXT_rejected: 'Revisa el pas rebutjat, corregeix el que s\'indica i torna\'l a pujar.',
        STATUS_TEXT_approved: 'La teva flota està aprovada. Ja pots treballar-hi.',
        STATUS_TEXT_suspended: 'Posa’t en contacte amb WAIIS per reactivar-la.',
        REJECTED_FIX: 'Corregeix-lo i torna\'l a pujar.',
        LOCKED_STEP: 'Aquest pas ja està enviat. Si el rebutgem, el podràs tornar a pujar.',
        ENTITY_REQUIRED: 'Tria si factures com a empresa o com a autònom.',
        FIELD_REQUIRED: 'Aquest camp és obligatori.',
        TAX_ID_INVALID: 'El NIF ha de tenir 9 caràcters.',
        POSTAL_CODE: 'Codi postal',
        POSTAL_CODE_INVALID: 'El codi postal té 5 xifres.',
        CITY: 'Localitat',
        PROVINCE: 'Província',
        VAT_PLACEHOLDER: 'Tria el règim d\'IVA',
        SAVE: 'Desar dades',
        SAVING: 'Desant…',
        SAVE_ERROR: 'No s\'han pogut desar les dades.',
        UPLOAD_ERROR: 'No s\'ha pogut pujar el document.',
        BANK_TEXT: 'Puja el certificat de titularitat del compte bancari de l\'empresa. Ha d\'estar a nom de l\'empresa i s\'hi ha de veure l\'IBAN complet.',
        ROUTE_SHEET_TEXT: 'Per poder emetre els fulls de ruta dels teus serveis, autoritza WAIIS al Registre de VTC del Ministeri i puja la captura de l\'autorització.',
        MISSING_STEPS: 'Completa tots els passos per enviar l\'alta.',
        SUBMIT: 'Enviar a revisió',
        SUBMITTING: 'Enviant…',
        SUBMIT_ERROR: 'No s\'ha pogut enviar l\'alta.',
      },
      OVERVIEW: {
        SUBTITLE: 'El més important de la teva flota d\'un cop d\'ull.',
        SEE_ONBOARDING: 'Veure l\'alta',
        CODE_TITLE: 'Codi de flota',
      },
    },
    // Menú y cabeceras de Admin › Taxi y VTC (se fusionan con los generales).
    SIDEBAR: {
      FLEET_SECTION: 'La meva flota',
      FLEET_ONBOARDING: 'Alta de la flota',
      FLEET_OVERVIEW: 'Resum',
      FLEET_DRIVERS: 'Conductors',
      FLEET_VEHICLES: 'Vehicles',
      FLEET_SHIFTS: 'Torns',
      FLEET_DOCUMENTS: 'Documents',
      FLEET_MONEY_SECTION: 'Diners',
      FLEET_SETTLEMENTS: 'Liquidacions',
      FLEET_REPORTS: 'Informes',
      FLEET_ADMIN_SECTION: 'Administració',
      FLEET_TEAM: 'Equip',
      FLEET_SETTINGS: 'Configuració',
      FLEET_LOCKED_DRAFT: 'Completa i envia l\'alta de la flota per fer servir aquesta secció.',
      DRIVERS_PRO: 'Taxi i VTC',
      DOCUMENT_REVIEWS: 'Verificació de documents',
      FLEETS: 'Flotes',
      PROFESSIONAL_DRIVERS: 'Conductors professionals',
    },
    PAGE_HEADER: {
      DOCUMENT_REVIEWS: 'Revisa a mà els documents que pugen les flotes i els conductors de taxi i VTC. El DNI el verifica Tecalis.',
      FLEETS: 'Flotes de taxi i VTC donades d\'alta, amb l\'estat de la seva revisió, els seus vehicles i els seus conductors.',
      PROFESSIONAL_DRIVERS: 'Conductors de taxi i VTC amb llicència pròpia o vinculats a una flota, i l\'estat de la seva alta.',
    },
  },
};
